import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { Box } from '@vio/atlas/helpers/Box';
import { Icon } from '@vio/atlas/Icon';
import { Text } from '@vio/atlas/Text';
import { Tooltip, TooltipPlacement } from '@vio/atlas/Tooltip';
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay';
import noop from 'lodash/noop';
import { OverlayType } from 'modules/overlay/types';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const _exp = /*#__PURE__*/() => Text;
const StyledText = /*#__PURE__*/styled(_exp())({
  name: "StyledText",
  class: "s1p2zt6i",
  propsAsIs: true
});
const Underlined = /*#__PURE__*/styled('span')({
  name: "Underlined",
  class: "u10ziwiy",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('span')({
  name: "IconWrapper",
  class: "igyl1gu",
  propsAsIs: false
});
export const RoomSwitchRequiredTooltip = () => {
  const {
    formatMessage
  } = useIntl();
  const [anchor, setAnchor] = useState(undefined);
  const {
    isDesktop
  } = useDeviceLayout();
  const showOverlay = useShowOverlay();
  const onClick: React.MouseEventHandler = useCallback(e => {
    e.stopPropagation();
    showOverlay({
      type: OverlayType.SplitBookingInfoBottomSheet
    });
  }, [showOverlay]);
  const label = <Box paddingTop={isDesktop ? 's200' : 's100'}>
      <Box display="inline-flex" onClick={isDesktop ? noop : onClick}>
        <StyledText variant="bodyXS" colorPath="content.neutral.c950">
          <Underlined data-chromatic="ignore">
            <FormattedMessageWrapper id="roomSwitchRequired" defaultMessage="Room switch required" />
          </Underlined>
        </StyledText>
        <IconWrapper ref={setAnchor}>
          <Icon name="Information" size="sm" />
        </IconWrapper>
      </Box>
    </Box>;
  if (isDesktop) {
    return <Tooltip anchor={anchor} placement={TooltipPlacement.BottomEnd} title={formatMessage({
      id: 'switchRoomsAndSave',
      defaultMessage: 'Switch rooms and save'
    })} content={<Box maxWidth="232px">
            <FormattedMessageWrapper id="splitBooking.roomSwitchRequiredTooltipContent" defaultMessage="The cheapest way to stay here is to split your stay across two separate bookings." />
          </Box>}>
        {label}
      </Tooltip>;
  }
  return label;
};

require("./RoomSwitchRequiredTooltip.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomSwitchRequiredTooltip.tsx");